"use client";

import { useState, useEffect } from "react";
import { Search, CarFront } from "lucide-react";
import { useVehicleSelection } from "@/context/VehicleContext";

export const MobileStickyFinder = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { selection } = useVehicleSelection();

  useEffect(() => {
    const handleScroll = () => {
      // Show the sticky bar after scrolling past the main hero section (~400px)
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] p-3 animate-in slide-in-from-bottom-full duration-300">
      <div className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-xl p-2.5">
        <div className="w-10 h-10 rounded-lg bg-[#005bb5]/10 flex items-center justify-center flex-shrink-0">
          <CarFront className="w-5 h-5 text-[#005bb5]" />
        </div>
        
        <div className="flex flex-col flex-1 min-w-0">
          <span className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold leading-none mb-1">
            Shopping For
          </span>
          <span className="text-[13px] font-bold text-slate-800 leading-none truncate block">
            {selection?.brandId && selection?.modelId 
              ? `${selection.yearLabel || ""} ${selection.brandName} ${selection.modelName}`
              : "Select Your Vehicle"}
          </span>
        </div>

        <button 
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Scroll to top and open vehicle finder"
          className="bg-[#005bb5] text-white p-2.5 rounded-lg hover:bg-[#004a99] transition-colors flex-shrink-0"
        >
          <Search className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
